import { DateTime } from 'luxon';
import * as yup from 'yup';

export const schedulesValidationSchema = yup.object({
  startDate: yup
    .string()
    .test({
      name: 'startDate',
      message: 'campaigns.form.scheduling.schedules.errors.start-date-too-late',
      test: (value: string, context: yup.TestContext) => {
        if (!context.parent.endDate || context.parent.scheduleStrategy === 'alwaysOn') {
          return true;
        }
        const endDate = DateTime.fromISO(context.parent.endDate).set({
          hour: 11,
          minute: 59,
          second: 59,
          millisecond: 0,
        });
        const startDate = DateTime.fromISO(value).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        return startDate <= endDate;
      },
    })
    .required('campaigns.ads.schedule.start-date-required'),
  scheduleStrategy: yup.mixed().oneOf(['alwaysOn', 'selectDates']).required(),
});
